export default "__VITE_ASSET__CoWCUmfw__"